export default __webpack_public_path__ + "static/media/intercam.5aae6696.png";